import { render, staticRenderFns } from "./CommunicationPrefContact.vue?vue&type=template&id=3c3505ec&scoped=true"
import script from "./CommunicationPrefContact.vue?vue&type=script&lang=js"
export * from "./CommunicationPrefContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3505ec",
  null
  
)

export default component.exports